import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCompareCheckComponent } from './product-compare-check.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ProductCompareCheckComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductCompare: {
          component: ProductCompareCheckComponent,
        },
      },
    }),
  ],
  exports: [ProductCompareCheckComponent],
})
export class ProductCompareCheckModule {}
